<div class="icon-nav">
  <ul>
    <li class="onhover-div mobile-search search-widgets" id="search-widgets">
      <div (click)="goToWishlist()">
        <img src="assets/images/icon/heart.png" class="img-fluid" alt="">
        <i class="ti-search"></i>
      </div>
    </li>
    <li class="onhover-div mobile-search search-widgets" id="search-widgets">
      <div (click)="goToOrder()">
        <img src="assets/images/icon/search1.png" class="img-fluid" alt="">
        <i class="ti-search"></i>
      </div>
    </li>
    <li class="onhover-div mobile-cart">
      <div>
        <a [routerLink]="['/shop/cart']">
          <img src="assets/images/icon/cart.png" class="img-fluid" alt="">
          <i class="ti-shopping-cart"></i>
        </a>
      </div>
      <span class="cart_qty_cls">{{ products.length }}</span>
      <ul class="show-div shopping-cart" *ngIf='!products.length'>
        <h5>Giỏ hàng của bạn trống.</h5>
      </ul>
      <ul class="show-div shopping-cart" *ngIf='products.length'>
        <li *ngFor="let product of products">
          <div class="media">
            <a [routerLink]="['/shop/products', product.id]">
              <img class="me-3" [src]="product?.images[0].imageUrl" [alt]="product?.images[0].id">
            </a>
            <div class="media-body">
              <a [routerLink]="['/shop/products', product.id]">
                <h4>{{ product?.name }}</h4>
              </a>
              <h4>
                <span>
                  {{ product?.quantity }} x
                  {{ product?.cost - (product.cost * product.discountPercent / 100) | currency:'VND'}}
                </span>
              </h4>
            </div>
          </div>
          <div class="close-circle" (click)="removeItem(product)">
            <a href="javascript:void(0)"><i class="fa fa-times" aria-hidden="true"></i></a>
          </div>
        </li>
        <li>
          <div class="total">
            <h5>Tổng : <span>{{ getTotal | async | currency:'VND' }}</span>
            </h5>
          </div>
        </li>
        <li>
          <div class="buttons">
            <a [routerLink]="['/shop/cart']" class="view-cart">Xem giỏ hàng</a>
            <a [routerLink]="['/shop/checkout']" class="checkout">Thanh toán</a>
          </div>
        </li>
      </ul>
    </li>
  </ul>
</div>